import { getTimezoneDate } from '@systemeio/ui'

export const getSecondsWithTimeZone = (seconds: number | null, timezone?: string) => {
  const userTime = getTimezoneDate(new Date(), timezone)
  const utcTime = getTimezoneDate(new Date(), 'UTC')
  const hoursDiff = userTime.getHours() - utcTime.getHours()
  const minutesDiff = userTime.getMinutes() - utcTime.getMinutes()
  const secondsDiff = hoursDiff * 3600 + minutesDiff * 60

  return typeof seconds === 'number' ? seconds - secondsDiff : null
}

const normalizeTo24HourRange = (seconds: number) => {
  const secondsInADay = 24 * 3600

  return (seconds + secondsInADay) % secondsInADay
}

export const getSecondsWithoutTimeZone = (seconds: number, timezone?: string) => {
  const userTime = getTimezoneDate(new Date(), timezone)
  const utcTime = getTimezoneDate(new Date(), 'UTC')

  const hoursDiff = userTime.getHours() - utcTime.getHours()
  const minutesDiff = userTime.getMinutes() - utcTime.getMinutes()

  const secondsDiff = hoursDiff * 3600 + minutesDiff * 60
  const adjustedSecondsDiff = normalizeTo24HourRange(secondsDiff)

  return normalizeTo24HourRange(seconds + adjustedSecondsDiff)
}
